const elementsToShow = document.querySelectorAll( '.animate' )

let scroll = window.requestAnimationFrame
let amountScrolled = 0
let scrolling = null
let startedScrollingUpWithinScrollThreshold = null

const body = document.body
const header = document.getElementById('header')
const scrollThreshold = 200


const init = function() {

  setTimeout( () => {
    loop()
    header.classList.add('is-initialized');
  }, 200 )

};


const loop = function() {
  watchForAnimationElements()
  updateHeaderClasses()
	scroll( loop )
};


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// FOR SCROLL TRANSITIONS
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const watchForAnimationElements = function() {

	elementsToShow.forEach( ( element ) => {
		const baseClass = 'animated';
		if ( isElementInViewport( element ) ) {
			if ( element.classList.contains( baseClass ) ) {
				return;
			}
			element.classList.add( baseClass );
		}
	});

}

// Fires repeatedly as the page is scrolled using request animation frame
const isElementInViewport = function( el ) {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// FOR HEADER VISIBILITY
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const updateHeaderClasses = function() {

  // wtoggle at-top class
  if ( amountScrolled <= 0 ) {
    body.classList.add('is-at-top')
    body.classList.remove('is-scrolling-up')
    body.classList.remove('is-scrolling-down')
  } else {
    body.classList.remove('is-at-top')
  }

  // add scroll direction class
  if ( amountScrolled > 0 ) {

    if ( scrolling === 'up' && amountScrolled < ( scrollThreshold * 2 ) ) {
      startedScrollingUpWithinScrollThreshold = true
    } else {
      startedScrollingUpWithinScrollThreshold = false
    }

    if ( scrolling === 'up' && !body.classList.contains('is-scrolling-up') ) {

      if ( !startedScrollingUpWithinScrollThreshold ) {
        body.classList.remove('is-scrolling-down')
        body.classList.add('is-scrolling-up')
      }

    } else if ( scrolling === 'down' && !body.classList.contains('is-scrolling-down') ) {
      body.classList.remove('is-scrolling-up')

      // to avoid triggering the .is-scrolling-down transition
      // a bit of distance is added
      if ( amountScrolled > ( scrollThreshold + 10 ) ) {
        body.classList.add('is-scrolling-down')
      }

    }

  }

  // toggle threshold class
	if ( getAmountscrolled() > scrollThreshold ) {
    body.classList.add('beyond-scroll-threshold')
	} else {
		body.classList.remove('beyond-scroll-threshold')
	}

}


const getAmountscrolled = function(){

	const pxScrolled = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
  
  if ( pxScrolled !== amountScrolled ) {
    scrolling = pxScrolled > amountScrolled ? 'down' : 'up'
    amountScrolled = pxScrolled  
  }
  
	return pxScrolled;

}


const api = {
	init: init
};

export default api;